import React from 'react'
import {
  Button,
  Card,
  Modal,
  Col,
  Form,
  Icon,
  Input,
  Collapse,
  Row, 
  message ,
   Spin,
  Switch,
  Cascader,
  Upload,
  notification,
} from 'antd'
import {connect} from 'react-redux'
import axios from 'axios' 
import {decode} from 'utf8'
import {updateProduct, fetchProduct} from 'appRedux/actions/Product'
const Panel = Collapse.Panel;
const FormItem = Form.Item
const { TextArea } = Input;
const AUTH_TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJoZWFkZXIiOnsiaWQiOiIwIiwidXNlciI6Ik1hbnVlbEdpbCJ9LCJwYXlsb2FkIjp7ImlhdCI6IjIwMTktMDEtMDEgMDA6MDA6MDAiLCJleHAiOiIyMDIwLTAxLTAxIDAwOjAwOjAwIn19.p_PtmXsDe3l_osPEzb4edkf-M2SCdUVBQBKs8ZAbpn8'

class Basic extends React.Component {
  state = {
    visible: false,
    id: '',
    name: '',
    price: '',
    category_id: '',
    urlVideo:'',
    validateStatus: '',
    videoUrl:'',

    statusResponse:'',
    validateId: '',
    validateDescription: '',
    validatePrice: '',
    validateName: '',

    helpId: '',
    helpDescription: '',
    helpPrice: '',
    helpName: '',

    admin_id: '',
  }

  showModal = () => {
    this.setState({
      admin_id: this.props.recording.admin_id,
      visible: true,
      id: this.props.recording.id,
      description: this.props.recording.description,
      price: this.props.recording.price,
      name: this.props.recording.name,
      urlVideo:this.props.recording.urlVideo,
     
    })
  }


  /*handlChangeVideo = selectorFiles => {
    const file = selectorFiles[0]
    this.setState({videoUrl: file})
  }*/

  handleCancel = e => {
    e.preventDefault()
    this.setState({
      id: '',
      description: '',
      price: '',
      category_id: '',
      urlVideo:'',
      videoUrl:'',
      statusResponse:1
    })
    console.log(this.state)
    this.props.fetchProduct()
    this.setState({visible: false})
    if (this.state.id == '') {
      this.setState({validateId: '', helpId: ''})
    }
    if (this.state.description == '') {
      this.setState({validateDescription: '', helpDescription: ''})
    }
    if (this.state.price == '') {
      this.setState({validatePrice: '', helpPrice: ''})
    }
    if (this.state.name == '') {
      this.setState({validateName: '', helpName: ''})
    }
  }

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: value || 'El producto se ha modificado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al cambiar el producto.',
      })
    }
  }
  handleChangeVideo = (info) => {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      this.setState({videoUrl:info.file.originFileObj})
      message.success(`${info.file.name} video cargado correctamente`);
console.log("state",this.state)
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} error al cargar el video`);
    }
  }


  createTest = async (id,name,description,price,videoUrl) => {
  
    const formData = new FormData()
    formData.append('id', id)
    formData.append('name', name)
    formData.append('description', description)
    formData.append('price', price)
    formData.append('file', videoUrl)
  
      const response =await axios({
      method: 'post',
      url: `https://admingreenerapp.crsostenible.com/api/public/api/app/product/edit`,
      data:formData,
      headers:{
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + AUTH_TOKEN
      }
    })
    .then(response =>{
      console.log('res',response)
      if(response.data.status==1){
        this.props.fetchProduct()
        console.log('res ex',response)
        this.setState({
           videoUrl: '',
          statusResponse:0
        })
        console.log('state en api',this.state)
        this.onNotification('success')
      }else{
        if(response==""){

        
        this.onNotification('info')
      }
      }
      
    })
 
  .catch(error => alert(error.message))
  
  }


  onHandleClick = event => {
    event.preventDefault()
    this.setState({
      statusResponse:2
    })
    console.log('status reposnse',this.state.statusResponse)
    let {id, description, price, name,videoUrl} = this.state
    if (this.state.validateStatus != 'error') {
      if (id && description && price && name != '') {
        this.createTest(id,name,description,price,videoUrl)

       
        /* this.props.updateProduct(this.state, () => {
          this.props.fetchProduct()
    
        })*/
        this.props.fetchProduct()
      } else {
        if (this.state.id == '') {
          this.setState({
            validateId: 'error',
            helpId: 'Id es un campo obligatorio.',
          })
        } else {
          this.setState({validateId: '', helpId: ''})
        }
        if (this.state.description == '') {
          this.setState({
            validateDescription: 'error',
            helpDescription: 'Nombre es un campo obligatorio.',
          })
        } else {
          this.setState({validateDescription: '', helpDescription: ''})
        }
        if (this.state.price == '') {
          this.setState({
            validatePrice: 'error',
            helpPrice: 'Precio es un campo obligatorio.',
          })
        } else {
          this.setState({validatePrice: '', helpPrice: ''})
        }
        if (this.state.name == '') {
          this.setState({
            validateCategory: 'error',
            helpCategory: 'Nombre es un campo obligatorio.',
          })
        } else {
          this.setState({validateName: '', helpName: ''})
        }
        this.onNotification(
          'error',
          'Rellene los campos obligatorios',
        )
      }
    } 
  }



  render() {
    let labelActionStatus;

    const statusResponse = this.state.statusResponse;
    let url=this.state.urlVideo
let videoReproductor=  <div style={{position:'relative', top:'-25px'}}>
<video key={url}  controls style={{width:'275px',borderRadius:'4px',transform: 'translate(20px, 20px)'}}>
    <source type="video/mp4" data-reactid=".0.1.0.0.0" src={url}/>
</video> 
</div>;



    if(statusResponse==2){
      labelActionStatus= <Spin className="gx-loader-container" tip="Actualizando el producto" />;

    }else{
      if(statusResponse==0){
        labelActionStatus=""
      }
    }
    const { Dragger } = Upload;
    const props = {
      name: 'file',
      action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
      headers: {
        authorization: 'authorization-text',
      },

      

    };
    return (
      <div>
        <Button type="primary" onClick={this.showModal}>
          <i className="icon icon-edit" />
        </Button>
        <Modal
          afterClose={() => this.props.fetchProduct()}
          okText="Editar"
          cancelText="Salir"
          title=""
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.handleCancel}
        >
          <Card className="gx-card" title="Editar producto">
            <form onSubmit={this.onHandleClick}>
            <Row className="padding-modal">
            <Col lg={5} md={5} sm={5} xs={5}> 
                  <FormItem
                    label="Nombre"
                    validateStatus={this.state.validateName}
                    help={this.state.helpName}
                  >
                  </FormItem>
                 </Col>
                 <Col lg={19} md={19} sm={19} xs={19}>
                    <Input
                      required
                      placeholder="Nombre del producto"
                      value={this.state.name}
                      onChange={event => {
                        this.setState({
                          name: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validateName: '',
                            helpName: '',
                          })
                        } else {
                          this.setState({
                            validateName: 'error',
                            helpName: 'Categoria es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  
                </Col>

                <Col lg={5} md={5} sm={5} xs={5}> 
                  <FormItem
                    label="Precio"
                    validateStatus={this.state.validatePrice}
                    help={this.state.helpPrice}
                  >
                  </FormItem>
                 </Col>
                 <Col lg={19} md={19} sm={19} xs={19}>
                    <Input
                      required
                      placeholder="Precio del producto"
                      value={this.state.price}
                      onChange={event => {
                        this.setState({
                          price: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validatePrice: '',
                            helpPrice: '',
                          })
                        } else {
                          this.setState({
                            validatePrice: 'error',
                            helpPrice: 'Precio es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  
                </Col>
                
                <Col lg={5} md={5} sm={5} xs={5}> 
                  <FormItem
                    label="Descripción"
                    validateStatus={this.state.validateDescription}
                    help={this.state.helpDescription}
                  >
                  </FormItem>
                 </Col>
                 <Col lg={19} md={19} sm={19} xs={19}>
                    <TextArea rows={4} 
                      required
                      placeholder="Descripción del producto"
                      value={this.state.description}
                      onChange={event => {
                        this.setState({
                          description: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validateDescription: '',
                            helpDescription: '',
                          })
                        } else {
                          this.setState({
                            validateDescription: 'error',
                            helpDescription: 'Nombre es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                 
                </Col>

                <Col lg={24} md={24} sm={24} xs={24}>
                  <Card type="inner" title="Video" style={{position:'relative',top:'30px'}}>


              <Col lg={19} md={19} sm={19} xs={19}>
            
            {videoReproductor}

            <Collapse style={{transform: 'translate(38px, 9px)'}}>
                <Panel header="Seleccionar video" key="1">
                        <FormItem
                             
                              labelCol={{xs: 12, sm: 12, lg: 12, md: 12}}
                            >
                          
                          <Dragger {...props} onChange={this.handleChangeVideo}>
    <p className="ant-upload-drag-icon">
    </p>
    <p className="ant-upload-text">Haga click o arrastre el video en formato mp4 a esta área para cargar</p>

                        </Dragger>
                      
                      </FormItem>
                </Panel>
             </Collapse>


            
            </Col>







                    
                  </Card>
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>

                {labelActionStatus}
                </Col>
 

              </Row>
            </form>
          </Card>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps({placeStores, products}) {
  return {
    placeStores,
    products,
  }
}
export default connect(
  mapStateToProps,
  {updateProduct, fetchProduct},
)(Basic)



// WEBPACK FOOTER //
// ./src/routes/main/Products/ModalEdit.js